
export const localizeHTML = ( s ) => {
  if (window.country) {
    if (s.includes('.html')) {
      const a = s.split('.html')
      return a[0] + '_' + window.country + '.html'
    }
  } else {
    return s
  }
};
export const localizeImage = ( s ) => {
  if (window.country) {
    if (s.includes('.jpg')) {
      const a = s.split('.jpg')
      return a[0] + '_' + window.country + '.jpg'
    } else if (s.includes('.png')) {
      const a = s.split('.png')
      return a[0] + '_' + window.country + '.png'
    }
  } else {
    return s
  }
};
